import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { SessionService } from '../../core/session.service';

@Component({
  selector: 'ch-login',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  email = '';
  password = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;
  error = '';
  mustChangePassword = false;
  showPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;

  constructor(
    private readonly api: ApiService,
    private readonly router: Router,
    private readonly session: SessionService
  ) {}

  async submit(): Promise<void> {
    this.loading = true;
    this.error = '';
    try {
      const result = await this.api.login(this.email, this.password);
      this.loading = false;
      if (result.user.force_password_change) {
        this.session.clear();
        this.mustChangePassword = true;
        this.error = '';
        return;
      }
      this.session.save(result);
      void this.router.navigateByUrl('/dashboard');
    } catch {
      this.loading = false;
      this.error = 'Login failed. Check your credentials and try again.';
    }
  }

  async changePassword(): Promise<void> {
    if (this.newPassword !== this.confirmPassword) {
      this.error = 'New password and confirmation must match.';
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      await this.api.changePassword(this.email, this.password, this.newPassword);
      this.password = this.newPassword;
      this.newPassword = '';
      this.confirmPassword = '';
      this.mustChangePassword = false;
      const result = await this.api.login(this.email, this.password);
      this.session.save(result);
      this.loading = false;
      void this.router.navigateByUrl('/dashboard');
    } catch {
      this.loading = false;
      this.error = 'Could not update password. Check the temporary password and try again.';
    }
  }
}
